import { render, staticRenderFns } from "./IndexTransferorBarChart.vue?vue&type=template&id=5e858cf0&"
import script from "./IndexTransferorBarChart.vue?vue&type=script&lang=js&"
export * from "./IndexTransferorBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports